// extracted by mini-css-extract-plugin
export default {"container":"Fk-z","disabled":"Gk-z","subtotal":"Hk-z","legal":"Ik-z"};